import React, { Component } from 'react'
import { Input, Button, Cascader } from 'hljd'
import Upload from '@common/Upload'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import store from './store'
import { changeField } from '@mixins'
import { HeaderView } from '@merchant-backend/common-components'

@changeField
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      location: {
        query: { status }
      }
    } = this.props

    if (status != 0) {
      store.getData()
    }
  }

  componentDidMount() {
    store.getCountry()
  }

  changeCondition = (type, fieldName, serial) => (...newValue) => {
    this.props.changeField(type, fieldName, {
      newValue,
      serial,
      isForm: true
    })(store)
  }

  uploadFront = (file, link) => {
    store.uploadFront(file, link)
  }

  uploadBack = (file, link) => {
    store.uploadBack(file, link)
  }

  render() {
    const {
      form: { name, address, contact_person, phone, spare_phone, email },
      front,
      back,
      country,
      town,
      logo_path,
      company_license
    } = store

    let options = country.map(item => {
      let province = {
        value: item.id,
        label: item.area_name,
        key: item.id
      }

      if (item.children) {
        province.children = item.children.map(item => {
          let city = {
            value: item.id,
            label: item.area_name,
            key: item.id
          }

          if (item.children) {
            city.children = item.children.map(item => {
              let town = {
                value: item.id,
                label: item.area_name,
                key: item.id
              }
              return town
            })
          }
          return city
        })
      }
      return province
    })

    return (
      <HeaderView title="升级账号">
        <div className={styles.upgrade}>
          <div className={styles.contain}>
            <div className={styles.item}>
              <span className={styles.must}>商家名称</span>
              <Input
                style={{ width: 300 }}
                onChange={this.changeCondition('input', 'name')}
                value={name}
              />
              <span className={styles.tip}>
                建议使用公司名称，不要使用当前门店名称，以免混淆
              </span>
            </div>
            <div className={styles.item}>
              <span className={styles.must}>LOGO</span>
              <Upload
                showDelete
                onDelete={store.removeLogo('logo_path')}
                link={logo_path ? logo_path + '?imageView2/2/w/200' : logo_path}
                onOk={store.uploadLogo('logo_path')}
              />
            </div>

            <div className={styles.item}>
              <span className={styles.must}>所在地区</span>
              <Cascader
                options={options}
                onChange={store.changeTown}
                value={toJS(town)}
                placeholder="请选择"
                style={{ width: 300 }}
              />
            </div>

            <div className={styles.item}>
              <span className={styles.must}>联系地址</span>
              <Input
                style={{ width: 300 }}
                onChange={this.changeCondition('input', 'address')}
                value={address}
              />
            </div>
            <div className={styles.item}>
              <span className={styles.must}>负责人</span>
              <Input
                style={{ width: 300 }}
                onChange={this.changeCondition('input', 'contact_person')}
                value={contact_person}
              />
            </div>

            <div className={styles.item}>
              <span className={styles.must}>联系电话</span>
              <Input
                style={{ width: 300 }}
                onChange={this.changeCondition('input', 'phone')}
                value={phone}
              />
            </div>

            <div className={styles.item}>
              <span className={styles.need}>备用电话</span>
              <Input
                style={{ width: 300 }}
                onChange={this.changeCondition('input', 'spare_phone')}
                value={spare_phone}
              />
            </div>

            <div className={styles.item}>
              <span className={styles.need}>电子邮箱</span>
              <Input
                style={{ width: 300 }}
                onChange={this.changeCondition('input', 'email')}
                value={email}
              />
            </div>

            <div className={styles.item}>
              <span className={styles.must}>负责人身份认证 身份证正面</span>
              <Upload
                showDelete
                onDelete={store.removeFront('front')}
                link={front ? front + '?imageView2/2/w/200' : front}
                onOk={store.uploadFront('front')}
              />
              <div className={styles.eg}>
                <p>示例：</p>
                <img src="http://qnm.hunliji.com/o_1b40mdafe154jstg1s9e1nemgojr.png" />
                <p className={styles.p2}>要求证件上的文字清晰可识别</p>
              </div>
            </div>

            <div className={styles.item}>
              <span className={styles.must}>身份证反面</span>
              <Upload
                showDelete
                onDelete={store.removeBack('back')}
                link={back ? back + '?imageView2/2/w/200' : back}
                onOk={store.uploadBack('back')}
              />
              <div className={styles.eg}>
                <p>示例：</p>
                <img src="http://qnm.hunliji.com/o_1b40mdcns1afr1n4p6ro19r8jk510.png" />
                <p className={styles.p2}>证件全部信息清晰无遮挡</p>
                <p className={styles.p2}>有效期在1个月以上</p>
              </div>
            </div>
            <div className={styles.item}>
              <span className={styles.need}>工商营业执照</span>
              <Upload
                showDelete
                onDelete={store.removeCompany_license('company_license')}
                link={
                  company_license
                    ? company_license + '?imageView2/2/w/200'
                    : company_license
                }
                onOk={store.uploadCompany_license('company_license')}
              />
            </div>
          </div>

          <div className={styles.btn}>
            <Button
              type="primary"
              onClick={store.doPost}
              className={styles.save}
            >
              确认升级
            </Button>
          </div>
        </div>
      </HeaderView>
    )
  }
}
